// extracted by mini-css-extract-plugin
export default {"cls1":"EmailRegistrationPage-cls1__a9b38587145f2f1cbcec","cls2":"EmailRegistrationPage-cls2___f85de429af5afa5f773 EmailRegistrationPage-cls1__a9b38587145f2f1cbcec"};